import React, { useRef, useState } from 'react'

import {
  AppBar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
} from '@material-ui/core'
import { AccountCircleOutlined } from '@material-ui/icons'

import logoDponetWhite from 'images/dponet-logo-white.svg'
import useAuthTraining from 'hooks/useAuthTraining'
import useTrainingPortalTheme from 'hooks/useTrainingPortalTheme'
import * as service from 'service'
import { routes } from 'TrainingRoutes'
import useStyles from './styles'

const TrainingMainLayout = ({ children }) => {
  const classes = useStyles()
  const { loaded, portalToken } = useAuthTraining()
  const { clientPortalTheme } = useTrainingPortalTheme()

  const logoUrl = clientPortalTheme?.logo || logoDponetWhite
  const anchorRef = useRef(null)
  const [menuOpen, setMenuOpen] = useState(false)

  if (!loaded) return null

  const handleLogout = () => {
    setMenuOpen(false)
    service.trainingPortal.auth.logout()
  }

  return (
    <Box className={classes.root}>
      <AppBar className={classes.appBar} position="fixed">
        <Toolbar className={classes.toolbar}>
          <img
            src={logoUrl}
            alt="Logo"
            className={classes.logo}
            onClick={() =>
              service.history.push(`/training/${portalToken}/home`)
            }
          />
          <Box flexGrow={1} />
          <IconButton
            ref={anchorRef}
            className={classes.userButton}
            onClick={() => setMenuOpen(true)}
          >
            <AccountCircleOutlined fontSize="large" />
          </IconButton>
          <Menu
            anchorEl={anchorRef.current}
            open={menuOpen}
            onClose={() => setMenuOpen(false)}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem
              onClick={() => {
                setMenuOpen(false)
                service.history.push(
                  routes.profile.replace(':portalToken', portalToken),
                )
              }}
            >
              Meu Perfil
            </MenuItem>
            <MenuItem onClick={handleLogout}>Sair</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <Box className={classes.content}>
        <Box className={classes.inner}>{children}</Box>
      </Box>
    </Box>
  )
}

export default TrainingMainLayout
